import script from "./CompanyCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyCard.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyCard.vue?vue&type=style&index=0&id=04a5df40&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a5df40"]])

export default __exports__